/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Intro_Region_Asia_DescriptionInputs */

const bn_intro_region_asia_description = /** @type {(inputs: Intro_Region_Asia_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`পূর্ণ এশিয়ান অঞ্চল, উপসাগর থেকে প্রশান্ত মহাসাগর পর্যন্ত।`)
};

const de_intro_region_asia_description = /** @type {(inputs: Intro_Region_Asia_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Der gesamte asiatische Raum, vom Golf bis zum Pazifik.`)
};

const el_intro_region_asia_description = /** @type {(inputs: Intro_Region_Asia_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Η πλήρης ασιατική περιοχή, από τον Κόλπο στον Ειρηνικό.`)
};

const en_intro_region_asia_description = /** @type {(inputs: Intro_Region_Asia_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The full Asian region, from the Gulf to the Pacific.`)
};

const es_intro_region_asia_description = /** @type {(inputs: Intro_Region_Asia_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toda la región asiática, desde el Golfo hasta el Pacífico.`)
};

const fr_intro_region_asia_description = /** @type {(inputs: Intro_Region_Asia_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toute l’Asie, du Golfe au Pacifique.`)
};

const hi_intro_region_asia_description = /** @type {(inputs: Intro_Region_Asia_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`संपूर्ण एशियाई क्षेत्र, खाड़ी से प्रशांत तक।`)
};

const hu_intro_region_asia_description = /** @type {(inputs: Intro_Region_Asia_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A teljes ázsiai régió, az Öböltől a Csendes-óceánig.`)
};

const id_intro_region_asia_description = /** @type {(inputs: Intro_Region_Asia_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seluruh wilayah Asia, dari Teluk hingga Pasifik.`)
};

const it_intro_region_asia_description = /** @type {(inputs: Intro_Region_Asia_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L'intera regione asiatica, dal Golfo al Pacifico.`)
};

const ja_intro_region_asia_description = /** @type {(inputs: Intro_Region_Asia_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`湾岸から太平洋までのアジア全域。`)
};

const ko_intro_region_asia_description = /** @type {(inputs: Intro_Region_Asia_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`걸프만에서 태평양까지 전체 아시아 지역.`)
};

const nl_intro_region_asia_description = /** @type {(inputs: Intro_Region_Asia_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De volledige Aziatische regio, van de Golf tot de Stille Oceaan.`)
};

const pl_intro_region_asia_description = /** @type {(inputs: Intro_Region_Asia_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cały region azjatycki, od Zatoki Perskiej po Pacyfik.`)
};

const pt_intro_region_asia_description = /** @type {(inputs: Intro_Region_Asia_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toda a região asiática, do Golfo ao Pacífico.`)
};

const ru_intro_region_asia_description = /** @type {(inputs: Intro_Region_Asia_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Весь азиатский регион, от Персидского залива до Тихого океана.`)
};

const sv_intro_region_asia_description = /** @type {(inputs: Intro_Region_Asia_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hela den asiatiska regionen, från viken till Stilla havet.`)
};

const tr_intro_region_asia_description = /** @type {(inputs: Intro_Region_Asia_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Körfez'den Pasifik'e kadar tüm Asya bölgesi.`)
};

const uk_intro_region_asia_description = /** @type {(inputs: Intro_Region_Asia_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Весь азіатський регіон, від Перської затоки до Тихого океану.`)
};

const vi_intro_region_asia_description = /** @type {(inputs: Intro_Region_Asia_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toàn bộ khu vực châu Á, từ vùng Vịnh đến Thái Bình Dương.`)
};

const zh_intro_region_asia_description = /** @type {(inputs: Intro_Region_Asia_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`整个亚洲地区，从海湾到太平洋。`)
};

const zh_hant_intro_region_asia_description = /** @type {(inputs: Intro_Region_Asia_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`整個亞洲地區，從海灣到太平洋。`)
};

/**
* | output |
* | --- |
* | "The full Asian region, from the Gulf to the Pacific." |
*
* @param {Intro_Region_Asia_DescriptionInputs} inputs
* @param {{ locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }} options
* @returns {LocalizedString}
*/
export const intro_region_asia_description = /** @type {((inputs?: Intro_Region_Asia_DescriptionInputs, options?: { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Intro_Region_Asia_DescriptionInputs, { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "bn") return bn_intro_region_asia_description(inputs)
	if (locale === "de") return de_intro_region_asia_description(inputs)
	if (locale === "el") return el_intro_region_asia_description(inputs)
	if (locale === "en") return en_intro_region_asia_description(inputs)
	if (locale === "es") return es_intro_region_asia_description(inputs)
	if (locale === "fr") return fr_intro_region_asia_description(inputs)
	if (locale === "hi") return hi_intro_region_asia_description(inputs)
	if (locale === "hu") return hu_intro_region_asia_description(inputs)
	if (locale === "id") return id_intro_region_asia_description(inputs)
	if (locale === "it") return it_intro_region_asia_description(inputs)
	if (locale === "ja") return ja_intro_region_asia_description(inputs)
	if (locale === "ko") return ko_intro_region_asia_description(inputs)
	if (locale === "nl") return nl_intro_region_asia_description(inputs)
	if (locale === "pl") return pl_intro_region_asia_description(inputs)
	if (locale === "pt") return pt_intro_region_asia_description(inputs)
	if (locale === "ru") return ru_intro_region_asia_description(inputs)
	if (locale === "sv") return sv_intro_region_asia_description(inputs)
	if (locale === "tr") return tr_intro_region_asia_description(inputs)
	if (locale === "uk") return uk_intro_region_asia_description(inputs)
	if (locale === "vi") return vi_intro_region_asia_description(inputs)
	if (locale === "zh") return zh_intro_region_asia_description(inputs)
	return zh_hant_intro_region_asia_description(inputs)
});